<template>
  <dt class="text-sm font-medium leading-5 text-gray-400">
    <slot />
  </dt>
</template>
